export const SEARCH_STATE = 'SEARCH_STATE';
export const FETCH_STATE = 'FETCH_STATE';
export const FETCH_ALL = 'FETCH_ALL';
export const CHART_DATA = 'CHART_DATA';
